/* Copyright (c) 2018 Scaper */

import { UserInfo } from "@firebase/auth-types";
import * as cx from "classnames";
import * as React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router";
import { Link, RouteComponentProps } from "react-router-dom";
import { IApi } from "../../api/api";
import { SetPhoneNumberPath } from "../../paths/pathIndex";
import { IAppState } from "../appState";
import { IUserPhoneNumberDocument } from "../userState";

import "./requirePhoneVerifiedOrPrompt.scss";

interface IOwnProps {
    api: IApi;
    children: (phoneNumberDocument: IUserPhoneNumberDocument) => JSX.Element;
    className?: string;
    userInfo: UserInfo;
}

interface IStateProps {
    phoneNumberDocument: IUserPhoneNumberDocument | false | undefined;
}

type IProps = IOwnProps & IStateProps;

class UnconnectedRequirePhoneVerifiedOrPrompt extends React.PureComponent<IProps & RouteComponentProps<any>, {}> {
    private unsubscribeFromPhoneNumber: (() => void) | undefined;

    public render() {
        const { children, className, location, phoneNumberDocument } = this.props;

        if (phoneNumberDocument == null) {
            return "// TODO: LOADING";
        }

        if (phoneNumberDocument === false) {
            const setPhoneNumberPath = SetPhoneNumberPath.of({ from: `${location.pathname}${location.search}` });
            return (
                <Link
                    className={cx("btn-large waves-effect waves-light", className, "scpr-RequirePhoneVerifiedOrPrompt-button")}
                    to={setPhoneNumberPath}
                >
                    <i className="material-icons left">phone</i>
                    ENTER PHONE NUMBER
                </Link>
            );
        }

        return children(phoneNumberDocument);
    }

    public componentDidMount() {
        const { api, userInfo } = this.props;
        this.unsubscribeFromPhoneNumber = api.userService.subscribeToPhoneNumber(userInfo);
    }

    public componentWillUnmount() {
        if (this.unsubscribeFromPhoneNumber != null) {
            this.unsubscribeFromPhoneNumber();
        }
    }
}

function mapStateToProps(state: IAppState): IStateProps {
    const { user } = state;
    const { phoneNumberDocument } = user;
    return { phoneNumberDocument };
}

export const RequirePhoneVerifiedOrPrompt = withRouter(connect<IStateProps, {}, IOwnProps, IAppState>(mapStateToProps)(UnconnectedRequirePhoneVerifiedOrPrompt));
